"use client";
import { jsxs as b, jsx as e } from "react/jsx-runtime";
import { cva as w } from "class-variance-authority";
import { forwardRef as N, useState as k } from "react";
import { twMerge as T } from "tailwind-merge";
import { cn as l } from "./index.es19.js";
import { Text as m } from "./index.es4.js";
const p = w(
  `
    px-6
    rounded-sm
    focus-visible:outline-2
    focus-visible:outline-blue-600
    focus-visible:outline-offset-2
    cursor-pointer
    text-center
    border-transparent
    border-2
    flex
    items-center
    justify-center
    gap-x-2
    w-full
`,
  {
    variants: {
      variant: {
        primary: "bg-yellow-400 hover:bg-yellow-600 text-gray-900",
        secondary: "bg-gray-800 hover:bg-gray-900 text-white",
        "outlined-dark": "border-gray-800 text-gray-800 hover:bg-gray-900 hover:text-white",
        "outlined-light": "border-white text-white hover:text-gray-800 hover:bg-white hover:border-gray-800",
        text: "bg-transparent text-blue-700 hover:bg-gray-100 hover:text-blue-800",
        alternate: "bg-blue-700 hover:bg-blue-800 text-white"
      },
      size: {
        default: "py-1-5 min-h-[40px]",
        large: "py-3 min-h-[56px]"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 border-gray-200 hover:border-gray-200 focus:outline-none hover:bg-gray-200 hover:text-gray-500 cursor-not-allowed"
      },
      isLink: {
        true: "inline-flex items-center"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), a = w("w-4 h-4 fill-current hover:fill-current", {
  variants: {
    variant: {
      primary: "fill-current hover:fill-current",
      secondary: "fill-white hover:fill-gray-900",
      "outlined-dark": "fill-gray-800 hover:fill-white",
      "outlined-light": "fill-current hover:fill-current",
      text: "fill-current hover:fill-current",
      alternate: "fill-white hover:fill-gray-200"
    },
    disabled: {
      true: "fill-gray-500 hover:fill-gray-500"
    }
  }
}), I = N(
  ({
    children: s,
    variant: t,
    className: x = "",
    size: i = "default",
    disabled: r = !1,
    href: u,
    iconPrefix: o,
    iconSuffix: c,
    ...h
  }, f) => {
    const g = i === "large" ? "base" : "sm", [F, d] = k(!1), v = (B) => {
      B.currentTarget.matches(":focus-visible") && d(!0);
    }, y = () => d(!1);
    let n;
    return u && !r ? n = /* @__PURE__ */ b(
      "a",
      {
        ...h,
        ref: f,
        className: l(p({ variant: t, size: i, disabled: r, isLink: !0 })),
        href: u,
        onFocus: v,
        onBlur: y,
        children: [
          o && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: o }),
          /* @__PURE__ */ e(m, { asChild: !0, fontSize: g, children: /* @__PURE__ */ e("span", { children: s }) })
        ]
      }
    ) : n = /* @__PURE__ */ b(
      "button",
      {
        ...h,
        ref: f,
        className: l(p({ variant: t, size: i, disabled: r })),
        disabled: r,
        onFocus: v,
        onBlur: y,
        children: [
          o && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: o }),
          /* @__PURE__ */ e(m, { asChild: !0, fontSize: g, children: /* @__PURE__ */ e("span", { children: s }) }),
          c && /* @__PURE__ */ e("div", { className: l(a({ variant: t, disabled: r })), children: c })
        ]
      }
    ), /* @__PURE__ */ e(
      "div",
      {
        className: T(
          "inline-block rounded-sm w-auto",
          F && "focus-within:outline-2 focus-within:outline-white focus-within:outline-offset-4",
          x
        ),
        children: n
      }
    );
  }
);
export {
  I as Button
};
